import { Injectable } from '@angular/core';
import { Result } from '@team23/ts-result';
import { Environment, EnvironmentStatus } from '@ui/shared/util-config';
import { Observable } from 'rxjs';

type EnvironmentResult = Result<Environment, EnvironmentStatus>;

/**
 * Read the app-specific environment config file. The `environment` getter should return the parsed environment.
 * In order to delay the app start until the environment file is read, import `ConfigModule` in the app module.
 */
@Injectable({ providedIn: 'root' })
export abstract class AbstractEnvironmentService {

    public abstract get environment(): EnvironmentResult;

    /**
     * Read the environment config with the http client and update `configuration$`.
     *
     * Should throw a console error if the config file is missing.
     */
    public abstract readEnvironmentFile(): Observable<EnvironmentResult>;
}
